import _typeof from 'babel-runtime/helpers/typeof';
export default {
  name: 'TableExpand',
  functional: true,
  inject: ['tableRoot'],
  props: {
    row: Object,
    render: Function,
    index: Number,
    column: {
      type: Object,
      'default': null
    }
  },
  render: function render(h, ctx) {
    var params = {
      row: ctx.props.row,
      index: ctx.props.index
    };
    if (ctx.props.column) params.column = ctx.props.column;
    var renderResult = ctx.props.render(h, params);
    if (renderResult) {
      if ((typeof renderResult === 'undefined' ? 'undefined' : _typeof(renderResult)) === 'object') {
        return renderResult;
      } else {
        return h('span', renderResult);
      }
    }
    return h('span', ctx.injections.tableRoot.placeholder);
  }
};